import {createApi} from '@reduxjs/toolkit/query/react';

import {isNotNil} from 'ramda';

import {dmsBaseQuery} from './dmsBaseQuery';
import {
  GetBusinessCaseOnlineOfferApiArg,
  GetBusinessCaseOnlineOfferApiResponse,
  GetPdfByOfferIdApiArg,
  GetPdfByOfferIdApiResponse,
  ListLogosApiArg,
  ListLogosApiResponse,
} from './types/onlineOfferTypes';

export const onlineOfferApi = createApi({
  baseQuery: dmsBaseQuery,
  reducerPath: 'onlineOfferApi',
  tagTypes: [],
  endpoints: (build) => ({
    getBusinessCaseOnlineOffer: build.query<
      GetBusinessCaseOnlineOfferApiResponse,
      GetBusinessCaseOnlineOfferApiArg
    >({
      query: (queryArg) => {
        const params = new URLSearchParams();
        if (isNotNil(queryArg.openedBy)) {
          params.set('openedBy', queryArg.openedBy);
        }
        const paramsToSet = params.toString();
        return {
          url: `/dms/v1/business-case/online-offer/${queryArg.offerId}/data${paramsToSet ? `?${paramsToSet}` : ''}`,
          headers: {'X-Workspace': queryArg.workspace},
        };
      },
    }),
    listLogos: build.query<ListLogosApiResponse, ListLogosApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/logo`,
        headers: {'X-Workspace': queryArg['X-Workspace']},
      }),
    }),
    getPdfByOfferId: build.query<GetPdfByOfferIdApiResponse, GetPdfByOfferIdApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/business-case/online-offer/${queryArg.offerId}/pdf`,
        params: {
          lang: queryArg.locale,
          filename: queryArg.filename,
          margin: '0px 0px 0px 0px',
          contentDisposition: 'attachment',
        },
        headers: {
          'X-Workspace': queryArg.workspace,
        },
      }),
    }),
  }),
});

export const {useGetBusinessCaseOnlineOfferQuery, useListLogosQuery, useLazyGetPdfByOfferIdQuery} =
  onlineOfferApi;
